import { RemoveFormatting } from "lucide-react";
import { KEYS } from "platejs";
import { useEditorRef } from "platejs/react";
import { memo, useCallback } from "react";
import { DropdownMenuItem } from "../ui/dropdown-menu";
import { ToolbarButton } from "./toolbar";
import { useToolbarOverflow } from "./toolbar-overflow";

const MARKS_TO_CLEAR = [
  KEYS.bold,
  KEYS.italic,
  KEYS.underline,
  KEYS.strikethrough,
  KEYS.color,
  KEYS.fontFamily,
  KEYS.fontSize,
] as const;

export const ClearFormattingToolbarButton = memo(
  function ClearFormattingToolbarButton() {
    const editor = useEditorRef();
    const { isOverflow } = useToolbarOverflow();

    const handleClick = useCallback(() => {
      for (const mark of MARKS_TO_CLEAR) {
        editor.tf.removeMarks(mark);
      }
      editor.tf.focus();
    }, [editor]);

    if (isOverflow) {
      return (
        <DropdownMenuItem onSelect={handleClick}>
          <RemoveFormatting />
          Clear formatting
        </DropdownMenuItem>
      );
    }

    return (
      <ToolbarButton
        Icon={RemoveFormatting}
        onClick={handleClick}
        tooltip="Clear formatting"
      />
    );
  },
);
